// extracted by mini-css-extract-plugin
export default {"empty":"EmptyOrder_empty__WZ6G8","empty__link_button":"EmptyOrder_empty__link_button__FxZ6K","empty_button":"EmptyOrder_empty_button__LHBvb"};